// extracted by mini-css-extract-plugin
export default {"image":"styles_image__d3Wqb"};